// extracted by mini-css-extract-plugin
export default {"available":"Status_available__1Sl4Y","full":"Status_full__T0V9R","empty":"Status_empty__tNukh"};